import { render } from "./ContactMe.vue?vue&type=template&id=6b4abc0b&scoped=true"
import script from "./ContactMe.vue?vue&type=script&lang=js"
export * from "./ContactMe.vue?vue&type=script&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=6b4abc0b&scoped=true&lang=css"

import exportComponent from "D:\\Learning\\Projects\\allankirui.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4abc0b"]])

export default __exports__